export default [
    {
        component: () => import(/* webpackChunkName: 'ambulatorio-recepcao' */ '@/views/ambulatorio/recepcao/Index'),
        path: 'recepcao',
        redirect: 'recepcao/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-recepcao' */'@/views/ambulatorio/recepcao/List.vue'),
                name: 'ambulatorio-recepcao-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-recepcao' */ '@/views/ambulatorio/recepcao/Form.vue'),
                name: 'ambulatorio-recepcao-create',
                path: 'create/:filaId?',
                props: route => ({filaId: parseInt(route.params.filaId)}),
            },
        ],
    },
]